(function () {
  function extractVideoId(url) {
    if (!url) return '';
    var shorts = url.match(/shorts\/([a-zA-Z0-9_-]+)/);
    if (shorts) return shorts[1];
    var watch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
    if (watch) return watch[1];
    var shortUrl = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (shortUrl) return shortUrl[1];
    return '';
  }

  function createCard(videoId, title) {
    var article = document.createElement('article');
    article.className = 'papis-shorts__card';
    article.setAttribute('data-video-id', videoId);

    var media = document.createElement('div');
    media.className = 'papis-shorts__media';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'papis-shorts__thumb';
    button.setAttribute('data-play-short', '');
    button.setAttribute('aria-label', 'Play short ' + (title || videoId));

    var img = document.createElement('img');
    img.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
    img.alt = title || 'YouTube Short';
    img.loading = 'lazy';
    img.width = 360;
    img.height = 640;

    var play = document.createElement('span');
    play.className = 'papis-shorts__play';
    play.setAttribute('aria-hidden', 'true');
    play.textContent = '▶';

    button.appendChild(img);
    button.appendChild(play);
    media.appendChild(button);
    article.appendChild(media);

    if (title) {
      var p = document.createElement('p');
      p.className = 'papis-shorts__title papis-display';
      p.textContent = title;
      article.appendChild(p);
    }

    return article;
  }

  function stopAllInline(root, exceptCard) {
    root.querySelectorAll('.papis-shorts__card.is-playing').forEach(function (card) {
      if (exceptCard && card === exceptCard) return;
      var media = card.querySelector('.papis-shorts__media');
      var videoId = card.getAttribute('data-video-id');
      var titleEl = card.querySelector('.papis-shorts__title');
      var title = titleEl ? titleEl.textContent : videoId;
      if (!media || !videoId) return;
      media.innerHTML = '';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'papis-shorts__thumb';
      button.setAttribute('data-play-short', '');
      button.setAttribute('aria-label', 'Play short ' + title);
      button.innerHTML =
        '<img src="https://i.ytimg.com/vi/' +
        encodeURIComponent(videoId) +
        '/hqdefault.jpg" alt="' +
        title.replace(/"/g, '&quot;') +
        '" loading="lazy" width="360" height="640">' +
        '<span class="papis-shorts__play" aria-hidden="true">▶</span>';
      media.appendChild(button);
      card.classList.remove('is-playing');
      button.addEventListener('click', function () {
        playInline(root, card);
      });
    });
  }

  function playInline(root, card) {
    if (!card || card.classList.contains('is-playing')) return;
    var videoId = card.getAttribute('data-video-id');
    var media = card.querySelector('.papis-shorts__media') || card;
    if (!videoId) return;

    stopAllInline(root, card);

    media.innerHTML =
      '<iframe class="papis-shorts__player" src="https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="YouTube Short" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    card.classList.add('is-playing');
  }

  function bindUi(root) {
    var track = root.querySelector('[data-shorts-track]');
    if (!track) return;

    root.querySelectorAll('[data-play-short]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-video-id]');
        if (card) playInline(root, card);
      });
    });

    var prev = root.querySelector('.papis-shorts__nav--prev');
    var next = root.querySelector('.papis-shorts__nav--next');
    var scrollBy = function (dir) {
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 240), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  function shuffle(list) {
    var items = list.slice();
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = items[i];
      items[i] = items[j];
      items[j] = temp;
    }
    return items;
  }

  function fetchPlaylistPage(playlistId, apiKey, pageToken) {
    var url =
      'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=' +
      encodeURIComponent(playlistId) +
      '&key=' +
      encodeURIComponent(apiKey);
    if (pageToken) {
      url += '&pageToken=' + encodeURIComponent(pageToken);
    }
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('YouTube API error');
      return res.json();
    });
  }

  function fetchAllPlaylistItems(playlistId, apiKey, pageToken, collected) {
    var all = collected || [];
    return fetchPlaylistPage(playlistId, apiKey, pageToken).then(function (data) {
      var items = (data && data.items) || [];
      all = all.concat(items);
      if (data.nextPageToken) {
        return fetchAllPlaylistItems(playlistId, apiKey, data.nextPageToken, all);
      }
      return all;
    });
  }

  function loadPlaylist(root) {
    var playlistId = (root.dataset.playlistId || '').trim();
    var apiKey = (root.dataset.apiKey || '').trim();
    var track = root.querySelector('[data-shorts-track]');
    if (!playlistId || !apiKey || !track) return Promise.resolve();

    return fetchAllPlaylistItems(playlistId, apiKey)
      .then(function (items) {
        if (!items.length) return;
        var cards = [];
        var seen = {};
        items.forEach(function (item) {
          var snippet = item.snippet || {};
          var videoId = snippet.resourceId && snippet.resourceId.videoId;
          if (!videoId || seen[videoId]) return;
          // Skip deleted / private placeholders
          if (snippet.title === 'Private video' || snippet.title === 'Deleted video') return;
          seen[videoId] = true;
          cards.push({ videoId: videoId, title: snippet.title || '' });
        });
        if (!cards.length) return;
        track.innerHTML = '';
        shuffle(cards).forEach(function (card) {
          track.appendChild(createCard(card.videoId, card.title));
        });
      })
      .catch(function () {
        /* Keep manual blocks if playlist fetch fails */
      });
  }

  function initShorts(root) {
    if (!root || root.dataset.papisShortsReady) return;
    root.dataset.papisShortsReady = 'true';

    // Wrap existing liquid thumbs in a media container for inline playback
    root.querySelectorAll('.papis-shorts__card').forEach(function (card) {
      if (card.querySelector('.papis-shorts__media')) return;
      var thumb = card.querySelector('.papis-shorts__thumb');
      if (!thumb) return;
      var media = document.createElement('div');
      media.className = 'papis-shorts__media';
      thumb.parentNode.insertBefore(media, thumb);
      media.appendChild(thumb);
    });

    loadPlaylist(root).finally(function () {
      bindUi(root);
    });
  }

  function boot() {
    document.querySelectorAll('.papis-shorts').forEach(initShorts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.papis-shorts');
    if (section) {
      delete section.dataset.papisShortsReady;
      initShorts(section);
    }
  });

  window.PapisShorts = { extractVideoId: extractVideoId };
})();
